import React, { useState, useEffect } from 'react';

const Info = () => {
    return (
        <section id="info-section">
            <h2>How It Works</h2>
            <p>
                Select your asset type, choose your timeframe, and set your art
                style.
            </p>
            <p>
                You are free to download and use any generated art however you
                wish.
            </p>
            <a href="#form-section" className="button--block">
                chArt It
            </a>
        </section>
    );
};

export default Info;
